import { render } from "./LogoImg.vue?vue&type=template&id=7af2f6ad&scoped=true&ts=true"
import script from "./LogoImg.vue?vue&type=script&lang=ts"
export * from "./LogoImg.vue?vue&type=script&lang=ts"

import "./LogoImg.vue?vue&type=style&index=0&id=7af2f6ad&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bakery-platform/bakery-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af2f6ad"]])

export default __exports__